// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2RH_l","calendarButtons":"ClockData_calendarButtons__LfwM-"};